@if (workspaceIsLoading()) {
  <korviu-loader></korviu-loader>
}
@if (!workspaceIsLoading()) {
  <div class="wrapper">
    <workspace-left-sidebar
      class="z-[999]"
      [(isCollapsed)]="leftSidebardCollapsed"
      #leftSideBar
    ></workspace-left-sidebar>
    <div class="working-area" id="working-area">
      <workspace-header
        class="fixed z-50 top-0 w-full lg:w-[calc(100%-340px)]"
        (leftSideBarUncollapseClick)="onUncollapseClick()"
      ></workspace-header>
      <div class="working-area-content mt-[80px] md:mt-[120px] pt-0 px-4 md:pt-0 sm:px-8 pb-[56px] md:pb-0">
        <workspace-breadcrumb id="workspace-main-breadcrumb" class="hidden"></workspace-breadcrumb>
        <router-outlet></router-outlet>
      </div>
      <unigana-footer></unigana-footer>
    </div>
  </div>
}
